import {PatEstadoConservacaoModel} from '@/models/patrimonio/patestadoconservacao/patestadoconservacao.model';
import api from '@/services/axios/api';
import {AxiosResponse} from 'axios';
import {DataSource, FiltrosModel} from '@/datasources/consulte-grid';
import TextoValor from '@/models/texto-valor';
import {RegisterOutput} from '@/models/register-output';

class PatEstadoConservacaoService {
 dadosIndexPaginado(pagina: number, itensPorPagina: number, filters: FiltrosModel[]): Promise<AxiosResponse<DataSource<PatEstadoConservacaoModel>>> {
  return api.post <DataSource <PatEstadoConservacaoModel>>('/PatEstadoConservacao/RetornoPaginado', {
   rowsPerPage:  itensPorPagina,
   pageNumber: pagina,
   filters: filters
  });
 }

 inserirAtualizar(patEstadoConservacao: PatEstadoConservacaoModel): Promise<AxiosResponse<RegisterOutput>> {
  const result = api.post('/PatEstadoConservacao', patEstadoConservacao);
  return result;
 }

 remover(id: number): Promise<AxiosResponse> {
  return api.delete('/PatEstadoConservacao/' + id);
 }

 atualizar(patEstadoConservacao: PatEstadoConservacaoModel): Promise<AxiosResponse> {
  return api.put('/PatEstadoConservacao', patEstadoConservacao);
 }

 async get(id: number): Promise<PatEstadoConservacaoModel> {
  const result = await api.get<PatEstadoConservacaoModel>(`/PatEstadoConservacao/${id.toString()}`);
  return result.data;
 }

 async DropDownList() : Promise<TextoValor[]> {
  const endpoint = "/PatEstadoConservacao/DropDownList";
  const result = await api.get(endpoint);
  // Mapeando os dados para o formato TextoValor
  return result.data.map((item: any) => ({
   valor: item.valor,
   texto: item.texto,
   }));
 }
}
export default new PatEstadoConservacaoService();
